import useAppManifest from "./use-app-manifest"

export function useShowBranding() {
  const manifest = useAppManifest()
  return (
    manifest.features?.treefortBranding !== "off" &&
    manifest.features?.treefortBranding !== "never"
  )
}
